import { fetchJson } from "@/utils/fetch";
import {
  APIOptions,
  CompanyType,
  ExpertiseType,
  GeoCodeType,
} from "@/services/type";

export async function autoCompleteCompanies(options?: APIOptions) {
  return fetchJson<CompanyType[]>(`/auto_complete/companies`, options);
}
export async function autoCompleteExpertises(options?: APIOptions) {
  return fetchJson<ExpertiseType[]>(`/auto_complete/expertises`, options);
}
export async function autoCompleteGeoCode(options?: APIOptions) {
  return fetchJson<GeoCodeType[]>(`/auto_complete/geocodes/details`, options);
}
